import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';

export class FileType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'File';

  friendlyName = 'File';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];
  superUserOnly = true;

  get default(): any {
    return {};
  }

  buildSchema() {
    return yup.object().nullable().default(null);
  }
}

const definition = new FileType();

Types.addBaseType(definition);
export { definition as FileDefinition };
